import React, { useState } from "react";
import LineChart from "../scrumBoard/LineChart";

function WorkingTimeGraph({ users, onClose, colourBlindMode }) {
	const getBackgroundColor = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return '#0033B1';
            default:
                return '#0000FF';
        }
    };

	const [userData, setUserData] = useState({
		// use the mapping in firebase context
		labels: users.userWorkingDate,
		datasets: [
			{
				label: "Total Working Hours",
				// an array of hour each day
				data: users.userWorkingHour,
				borderColor: getBackgroundColor(colourBlindMode),
       			backgroundColor: getBackgroundColor(colourBlindMode)
			},
		],
	});

	const options = {
		plugins: {
			legend: {
				position: "top",
			},
			title: {
				display: true,
				// change to the username
				text: users.userName + " | Total Working Hour: " + users.userTotalWorkingHour,
			},
		},
		scales: {
			x: {
				title: {
					display: true,
					text: "Days",
				},
			},
			y: {
				title: {
					display: true,
					text: "Hours",
				},
			},
		},
	};

	return (
		<div className="fixed block z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] top-0 left-0">
			<div className="flex justify-center items-center z-40 relative pt-[200px] pl-[400px]">
				<div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
					{/* Header for Form */}
					<div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center mb-[80px]" onClick={() => console.log(users)}>
						Total Working Time
					</div>

					<div className="bg-modalbg flex mt-[20px] justify-center">
						<div className="bg-[#E1DFDF] h-[350px] w-full mr-[15px] ml-[15px]">
							<LineChart chartData={userData} labels={options} />
						</div>
					</div>
					<div className="flex mt-[32.5px] justify-center mb-[20px]">
						<button
							className="bg-[#616675] px-[30px] py-[5px]"
							onClick={onClose}
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default WorkingTimeGraph;
